import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './CreditEditScreen';
import CreditEdit from './CreditEditScreen';
import { StoreState } from 'src/store/reducers';
import { getCredit } from 'src/store/actions/credit-actions';
import { getFormValues } from 'redux-form';
import { QueryParams } from '../../../../../../types/grid';
import { getStudentsSmall } from '../../../../../../store/actions/student-actions';
import { getDistrictsSmall } from '../../../../../../store/actions/district-actions';
import { getVendorsSmall } from '../../../../../../store/actions/vendor-actions';
import { getInvoices } from '../../../../../../store/actions/invoice-actions';
import { getServiceTypes } from '../../../../../../store/actions/service-type-actions';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        credit: state.credits.current,
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        providers: selectNameProviders(state),
        vendors: selectNameVendors(state),
        invoices: state.invoices.data,
        inProgress: state.invoices.inProgress,
        serviceTypes: state.serviceTypes.data,
        valuesForm: getFormValues('credit-form')(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getCredit(id)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getInvoices: (params: QueryParams) => dispatch(getInvoices(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
    };
}

const CreditEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CreditEdit);

export default CreditEditScreen;
